<template>
  <b-modal modal-class="santa-image-viewer" hide-footer id="santa-image-viewer" @hide="hide()" size="lg">
<!--    <div class="next-img">-->
<!--      <BIconChevronLeft />-->
<!--    </div>-->
    <div class="img-container">
      <img :src="src_url" :alt="src_url" >
    </div>
<!--    <div class="prev-img">-->
<!--      <BIconChevronRight />-->
<!--    </div>-->
  </b-modal>
</template>

<script>
export default {
  name: "ViewImage",
  props: {
    src: {
      type: String,
      default: null
    },
    show: {
      type: Boolean,
      default: false
    },
    hide: {
      type: Function,
      default() {
        this.$emit("update:show", false);
      }
    }
  },
  data() {
    return {
      src_url: this.src
    }
  },
  watch: {
    src(newVal) {
      this.src_url = newVal
    },
    show(newVal) {
      let self = this;
      this.$emit("update:show", newVal);
      let modal_action = newVal ? 'show' : 'hide';
      self.handleModalAction(modal_action);
    }
  },
  methods: {
    imagePreview(url) {
      let self = this;
      self.src_url = url;
      self.$emit("update:show", true);
      self.handleModalAction("show");
    },
    /*
    * action = show | hide
    * */
    handleModalAction(action) {
      this.$bvModal[action]("santa-image-viewer");
    }
  }
}
</script>

<style scoped>

</style>